/**
 * Переменные параметры приложения
 * Application parameters variables
 */
export const environment = {
  /**
   * Тип развертки приложения
   * Application run mode
   */
  production: true,
  /**
   * Адрес API панели администрирования
   * Administration panel api address
   */
  apiUrl: 'http://172.25.47.50:81',
  /**
   * Адрес авторизационного гаранта
   * Authorization garant address
   */
  issuerAuthority: 'http://localhost:82',
  /**
   * Адрес перенаправления на себя после успешной аутентификации (должен совпадать с таким же значением на стороне гаранта)
   * Self redirection address after successful authentication (must be exact same as defined in garant)
   */
  selfRedirect: 'http://localhost/',
  /**
   * Статичные преднамеренные значения справочников
   * Static predefined handbooks values
   */
  handbooksStaticFIelds: {
    /**
     * Идентификатор аналитического типа активности
     * Analytical activity type id
     */
    AnalyticalActivityTypeId: 1,
    /**
     * Идентификатор оперативного типа активности
     * Operational activity type id
     */
    OperationalActivityTypeId: 2
  }
};